import { ExpressionLogicalOperatorEnum, WhereClauseCompoundExpression } from "../ars_ldm";
import { isObjectRecord } from "./isObjectRecord";
import { isSubClause } from "./isSubClause";

/**
 * Type guard to check if a value is a WhereClauseCompoundExpression.
 *
 * Validates logical operator constraints:
 * - If logicalOperator is NOT, whereClauses must have 0 or 1 items
 * - If whereClauses has 2 or more items, logicalOperator must be AND or OR
 *
 * @param obj - The value to check
 * @returns True if the value is a WhereClauseCompoundExpression
 */
export const isWhereClauseCompoundExpression = (
  obj: unknown,
): obj is WhereClauseCompoundExpression => {
  // Check object
  if (!isObjectRecord(obj)) return false;
  // Check properties exist
  const chkObj = obj as WhereClauseCompoundExpression;
  if (!Object.values(ExpressionLogicalOperatorEnum).includes(chkObj.logicalOperator)) return false;
  if (
    chkObj.whereClauses !== undefined &&
    (!Array.isArray(chkObj.whereClauses) || chkObj.whereClauses.some((item) => !isSubClause(item)))
  )
    return false;
  // Validate logical operator constraints
  const whereClausesCount = chkObj.whereClauses?.length ?? 0;
  // If NOT, max 1 whereClause
  if (chkObj.logicalOperator === ExpressionLogicalOperatorEnum.NOT && whereClausesCount > 1)
    return false;
  // Everything is good
  return true;
};
